export const xlsxPicker = {
	sheetHumanizeErrorMessage: {
		verifyBaseSheet:
			", por favor verifique el modelo de la hoja de cálculo ejemplo o utilícela como hoja de cálculo base.",
		unidentifieldColumn: "Error en los nombres de las columnas",
		emptySheet: "Esta hoja de cálculo está vacía",
		emptySheetRows:
			"Esta hoja de cálculo tiene filas vacías, por favor elimine las filas vacías.",
		emptyHeaderCell: "Faltan nombres en las columnas",
		sheetPoorlyFormatted:
			"Formatee la hoja de cálculo para fuente Calibri, tamaño 11, elimine los espacios, saltos de línea innecesarios y negrita",
		default: "Ocurrió un error al importar la hoja de cálculo",
	},
	sheetNameExample: "(ejemplo)",
	sheetNameInvalid: "(inválida)",
	sheetDownload: "Descargar tabla ejemplo",
	sheetXlsxPicker: "Elija una hoja de cálculo",
	sheetFeedback: {
		successMessage: "¡Hoja de cálculo válida!",
		errorMessage:
			"Hoja de cálculo inválida, descárguela nuevamente y haga los cambios necesarios.",
	},
	duplicateError:
		"Se han identificado valores duplicados en la hoja de cálculo enviada.\n\nPor favor, revise el archivo, corrija los elementos duplicados y envíe nuevamente para continuar.",
	invalidSheetFormat:
		"La hoja de cálculo enviada tiene un formato inválido para este lugar.\n\nPor favor, utilice el formato correcto basado en el país del lugar y envíe nuevamente.",
	columns: {
		name: "Nombre",
		category: "Categoría",
		menuCategory: "Categoría del menú",
		description: "Descripción",
		image: "Imagen",
		hasAlcohol: "¿Contiene alcohol?",
		price: "Precio",
		variablePrice: "Precio variable",
		kind: "Tipo de producto",
		fiscalCode: "SKU",
		ncm: "Fiscal - NCM",
		cest: "Fiscal - CEST",
		fiscalProductGroup: "Fiscal - Grupo fiscal",
		fiscalProfile: "Fiscal - Perfil fiscal",
		fiscalIcmsBaseCalculoRetSt:
			"Base de cálculo del ICMS retenido en la operación anterior",
		fiscalIcmsValorSubistituto: "Valor del ICMS propio del sustituto",
		fiscalIcmsAliquotaFinal: "Alícuota soportada por el consumidor final",
		id: "Id del producto",
		products: "productos",
		bars: "Bares",
		beerBrand: "Marca de la cerveza",
		beerStyle: "Estilo de la cerveza",
		beerAbv: "ABV - Contenido alcohólico",
		isStockable: "Almacenable",
		fileName: "productos_{{placeName}}",
	},
	cell: {
		trueHasAlcohol: "VERDADERO",
		falseHasAlcohol: "FALSO",
	},
};
